var _path, _ellipse, _ellipse2, _ellipse3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCommunity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M30.216 5.625a4.72 4.72 0 0 0-4.72 4.72v7.015a4.72 4.72 0 0 0 4.72 4.72h6.768l5.04 4.814 5.04-4.813h6.719a4.72 4.72 0 0 0 4.72-4.721v-7.015a4.72 4.72 0 0 0-4.72-4.72H30.216Z",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.58,
    cy: 35.615,
    fill: "#2C5684",
    rx: 7.085,
    ry: 6.767
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.741,
    cy: 38.075,
    fill: "#2C5684",
    rx: 7.085,
    ry: 6.767
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.582,
    cy: 38.075,
    fill: "#2C5684",
    rx: 7.085,
    ry: 6.767
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M63.173 55.271v1.531c0 .87-.705 1.574-1.574 1.574H3.4c-.869 0-1.573-.705-1.573-1.574V55.5c2.485-3.639 6.785-6.044 11.673-6.044 2.757 0 5.328.766 7.491 2.087 2.929-2.898 7.038-4.701 11.588-4.701 4.55 0 8.66 1.803 11.588 4.701a14.34 14.34 0 0 1 7.493-2.087c4.784 0 9.006 2.305 11.513 5.815Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommunity);
export default __webpack_public_path__ + "static/media/icon-community.e97f3e1c3ecf2c0dca60932b617733de.svg";
export { ForwardRef as ReactComponent };